// ===---- Навигация ----===
window.onscroll = function () {
	scrollNavBar();
};

let navBar = document.querySelector('.vg-header-wrapper'),
	sticky = navBar.offsetTop;

function scrollNavBar() {
	if (window.pageYOffset >= sticky) {
		navBar.classList.add('fixed')
	} else {
		navBar.classList.remove('fixed');
	}
}

